import React from 'react';
import { Link } from 'react-router-dom';

export default function SiteFooter() {
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="site-footer-inner">
        <span className="muted">© {new Date().getFullYear()} AI Framework</span>
        <nav className="site-footer-links">
          <Link to="/disclosure" data-testid="footer-disclosure-link">Disclosure</Link>
          <Link to="/submit">Submit a tool</Link>
          <Link to="/discover">Discover</Link>
          <Link to="/contact" data-testid="footer-contact-link">Contact</Link>
        </nav>
      </div>
    </footer>
  );
}
